export default {
  //Item photo
  Photo: "Foto",
  ChoosePhoto: "Escolher foto",
  RemovePhoto: "Remover foto",
  //Order panel
  CurrentOrder: "Pedido atual",
  NoItemsYet: "Nenhum item ainda",
  TapAnItemToAddIt: "Toque em um item para adicioná-lo ao pedido",
  //Login
  SetOwnerPin: "Digite seu Codígo",
  SetPin: "Digite o Codígo",
  EnterValidName: "Digite um nome valido",
  PinMustBeExactly4Characters: "Codigo deve ter exactamente 4 caracteres",
  PinCodeDoesNotMatch: "Codigo não coincide",
  //Drawer
  Sales: "Vendas",
  Receipts: "Recibos",
  Listings: "Listagens",
  Shift: "Turnos",
  ShiftReports: "Relatorio de Turnos",
  Settings: "Configurações",
  LogoutAttendant: "Sair do Atendedor de Mesa",

  //Sales
  Subtotal: "Subtotal",
  Tax: "Imposto",
  Discounts: "Descontos",
  TotalPayment: "Total Geral",
  Favorites: "Favoritos",
  All: "Todos",
  Payment: "Pagamento",
  ItemFavorites: "Favorito de Itens",
  WouldYouLikeToIncludeTheItemAsFavorites:
    "Gostaria de incluir o Item como Favorito?",
  WouldYouLikeToRemoveTheItemAsFavorites:
    "Gostaria de remover o Item dos Favoritos?",
  EditPrice: "Editar Preço",
  SetPrice: "Digitar Preço",
  EditTransactionLine: "Editar Linha de Transação",
  Quantity: "Quantidade",
  SetQuantity: "Digitar Quantidade",
  Set: "Digitar",
  SetCommission: "Digitar Comissão",
  Add: "Adicionar",
  ReceiptLineIsDeleted: "Linha do Recibo foi Apagada",
  Okay: "Okay",
  ItIsNotYourShift: "Não é o seu Turno",
  //Sales Delete Icon
  ConfirmDelete: "Confirma Apagar",
  AreYouSureToDeleteReceiptLines:
    "Tem a certeza em apagar as linhas do Recibo?",
  No: "Não",
  Yes: "Sim",

  //Sales Discount Icon
  Discount: "Desconto",
  PleaseAddAnItem: "Por favor adicione um Item",
  OK: "OK",
  OnTheFlyDiscount: "Desconto rapido",
  ExistingDiscount: "Desconto Existente",
  DiscountType: "Tipo de Desconto",
  Percentage: "Percentagem",
  SetDiscount: "Digitar Desconto",
  FixDiscount: "Valor Fixo",
  CurrentDiscountSelected: "Desconto Currente Selecionado",
  NoSelectedDiscount: "Sem Desconto Selecionado",
  SelectNewDiscount: "Selecione Novo Desconto",

  //Sales Search
  SearchItems: "Procure nos Itens",

  //Sales View Orders
  ViewOrders: "Visualizar Pedidos",
  NoOrdersYet: "Sem Pedidos",
  ConfirmOrder: "Confirmar Pedido",
  SelectOrderType: "Selecione o Tipo de Ordem",
  Cancel: "Cancelar",
  Confirm: "Confirmar",
  AnyPendingTransactionsWillBeOverridedWouldYouLikeToContinue:
    "Qualquer Transação Pendente será Substituida. Quer continuar?",
  Orders: "Pedidos",
  ORDER: "PEDIDO",
  CancelOrder: "Cancelar Pedido",
  TableNo: "Mesa Num.",
  TableNumber: "Numero da Mesa",
  ChangeTable: "Alterar Mesa",
  ReprintOrder: "Re-imprimir Pedido",

  //Payment
  Pay: "Pagar",
  AmountDue: "Montante em Divida",
  AmountChange: "Troco",
  Customer: "Cliente",
  PaymentType: "Tipo de Pagamento",
  PrinterStatus: "Status da Impressora",
  NoDefaultPrinter: "Sem Impressora Default",
  AddCustomer: "Adicionar Cliente",
  Cash: "Dinheiro",
  Card: "Cartão",
  ConfirmPayment: "Confirmar Pagamento",
  AreYouSure: "Tem a Certeza?",
  Proceed: "Proceder",
  ReceiptInformation: "Informação do Recibo",
  DoYouWantToPrintReceipt: "Deseja Imprimir o Recibo",
  Close: "Fechar",
  TransactionSummary: "Resumo de Transação",
  CashPaid: "Valor Pago em Dinheiro",
  Commission: "Comissão",
  Alert: "Alerta",
  AmountPaidMustBeGreaterThanOrEqualToAmuntDue:
    "Valor Pago deve ser maior que ou igual ao Montante em Divida",
  Email: "Email",
  PhoneNumber: "Numero de Telefone",
  Note: "Nota",
  Save: "Salvar",
  NoAddedPrinterDevice: "Sem Impressora instalada",

  //Receipt
  NoReceiptsAvailable: "Não tem Recibos Disponíveis",
  Receipt: "Recibo",
  Completed: "Completo",
  Attendant: "Atendedor",
  Offline: "Offline",
  Reprint: "Re-imprimir",
  CancelReceipt: "Cancelar Recibo",
  SoldTo: "Vendido a:",
  Total: "Total",
  NoTax: "Sem Imposto",
  NoDiscount: "Sem Desconto",
  AmountPaid: "Valor Pago",
  Transaction: "Transação",
  VoidReceipt: "Recibo de Retorno",
  AreYouSureYouWantToVoidReceipt: "Tem a certeza que quer retornar o Recibo?",
  Reason: "Motivo",
  Cancelled: "Cancelado",

  //Listings
  Items: "Itens",
  Item: "Item",
  Categories: "Categoria",
  WouldYouLikeToCreateNewItem: "Quer criar um novo Item?",
  WouldYouLikeToCreateNewCategory: "Quer criar uma nova Categoria?",
  WouldYouLikeToCreateNewDiscount: "Quer criar um novo Desconto?",
  CreateNewItem: "Criar um novo Item",
  CreateNewCategory: "Criar nova Categoria",
  CreateNewDiscount: "Criar novo Desconto",

  //Listings Items
  Category: "Categoria",
  NoCategory: "Sem Categoria",
  Price: "Preço",
  Barcode: "Codigo de Barras",
  SoldBy: "Vendido por",
  Each: "Cada",
  Weight: "Peso",
  OtherInformation: "Outras Informações",
  StockKeepingUnit: "Unidade de Stock",
  Color: "Cor",
  Shape: "Formato",
  ShowOptions: "Mostrar Opções",
  PrintBarcode: "Imprimir Codigo de Barras",
  HideOptions: "Esconder Opções",
  SaveNewItem: "Salvar novo Item",
  SuccessfullyAddedNewItem: "Novo Item adicionado com sucesso",

  //Listings categories
  CategoryName: "Nome da Categoria",
  ColorWillApplyToAllItemsUnderThisCategoryForWhichColorIsNotSet:
    "Cor será aplicada a todos os Itens desta categoria caso não tenha",
  SaveNewCategory: "Salvar nova Categoria",
  EnterValidCategoryName: "Digite um Nome Valido de Categoria",
  EnterValidDiscountName: "Digite um Nome de Desconto valido",
  EnterAValidItemName: "Digite um Nome de Item valido",
  EnterValidDiscountValue: "Digite um Valor de Desconto valido",
  SuccessfullyAddedCategory: "Adicionou Categoria com sucesso",
  SuccessfullyAddedDiscount: "Adicionou Desconto com sucesso",

  //Listings Discounts
  DiscountName: "Nome do Desconto",
  DiscountValue: "Valor do Desconto",
  Role: "Regra",

  //Shift
  InputValidReason: "Digite um Motivo valido",
  AddedCash: "Adicionou Dinheiro",
  CashPayoutIsGreaterThanTheCashAvailable:
    "Pagamento em Dinheiro é maior que o Dinheiro disponível",
  RemovedCash: "Dinheiro Removido",
  ShiftDetails: "Detalhes de Turno",
  Amount: "Valor",
  Payin: "Entrada-de-valores",
  Payout: "Saida-de-valores",
  ShiftStarted: "Turno Iniciado",
  ShiftStartedOn: "Turno Iniciou as",
  BeginningCash: "Valor Inicial",
  EndingCash: "Valor Final",
  ShiftOpenedBy: "Turno aberto por",
  CloseShift: "Fechar Turno",
  TheCashYouWantedToPutIntoTheRegisterOrGetOutFromTheRegister:
    "Quer o Dinheiro no Registo ou fora do Registo",
  ActualMoney: "Valor actual",
  SetActualMoney: "Digite o valor actual",
  InvalidAmount: "Valor Invalido",
  EndedShift: "Terminou o Turno",
  WorkedFor: "Trabalhou por",
  AndEndedOn: "e terminou as",
  StartAnotherShift: "Iniciar outro Turno",
  TheCashByTheStartOfTheShift: "O valor do Inicio do Turno",
  EnterABeginningCash: "Digite um valor Inicial",

  //Shift Reports
  ItemSalesReport: "Relatorio de Vendas de Itens",
  CommissionReport: "Relatorio de Comissões",
  GenerateZReading: "Gerar Leitura Z",
  NoZReadingGenerated: "Não foi criado Leitura Z",
  ZReadin: "Leitura Z",
  Opened: "Aberto",
  by: "por",
  TotalNetSales: "Total Iliquido",
  Transactions: "Transação",
  OpeningAmount: "Valor de Abertura",
  ExpectedDrawer: "Valor na Gaveta",
  Short: "Em Falta",
  CashSales: "Vendas a Dinheiro",
  Payouts: "Pagamentos",
  Payins: "Entrada de Dinheiros",
  Taxes: "Impostos",
  Commissions: "Comissões",
  PrintXReport: "Imprimir Relatorio X",
  ShiftInfo: "Informação de Turno",
  PrintReport: "Imprimir Relatorio",
  PrintCommissions: "Imprimir Comissão",
  Name: "Nome",
  PrintZReport: "Imprimir Relatorio Z",

  //Settings
  //Bluetooth
  Bluetooth: "Bluetooth",
  Company: "Empresa",
  Sync: "Sincronizar",
  Queueing: "Em Fila",
  Printer: "Impressora",
  RegisteredDevices: "Aparelhos Registados",
  AvailableDevices: "Aparelhos Disponiveis",
  BluetoothScanner: "Scaner de Bluetooth",
  Enable: "Activar",
  Connected: "Conectado",
  Connecting: "Conectando...",
  NotConnected: "Nao Conectado",
  AddDevice: "Adicionar Aparelho",
  AreYouSureYouWantToAddThisDevice:
    "Tem a certeza que quer adicionar este Aparelho?",
  AreYouSureYouWantToRemoveThisDevice:
    "Tem a certeza que quer remover este Aparelho?",
  SuccessfullyAddedDevice: "Aparelho Adicionado com Sucesso",
  SuccessfullyRemovedDevice: "Aparelho Removido com Sucesso",
  RemoveDevice: "Remover Aparelho",

  //Company
  CompanySettings: "Configurações da Empresa",
  Currency: "Moeda",
  CompanyHeader: "Cabeçalho da Empresa",
  CompanyFooter: "Rodapé da Empresa",
  CurrentlyEditingPleaseSaveYourChanges:
    "Editando de momento. Por favor salve as alterações",

  //Attendant
  AddRole: "Adicionar um Regra",
  AttendantName: "Nome do Atendedor",
  CanLogin: "Pode fazer o Login",
  SaveAttendant: "Salvar o Atendedor",
  Pin: "Codigo",
  ConfirmPin: "Confirmar Codigo",
  SuccessfullyAddedAttendant: "Adicionou com Sucesso o Atendedor",
  EnterValidPin: "Digite um Codigo valido",
  PleaseConfirmPin: "Por favor confirmar o Codigo",

  //Sync
  Server: "Servidor",
  SyncSettings: "Configurações de Sincronização",
  Username: "Utilizador",
  Password: "Senha",
  DeviceID: "ID do Aparelho",
  PleaseClickTheEditButton: "Por favor aperte no Botão editar (icone de lapis)",
  EnterValidAttendantName: "Digite um Nome valido de Atendedor",
  //Queueing
  OtherSettings: "Outras configurações",
  UseDescription: "Usar Descrição",
  DescriptiveItemNamesInTheListing: "Nomes Descritivos de Item nas listagens",
  UseDefaultCustomer: "Usar Cliente Default",
  SetItemStacking: "Pôr item por ordem de Pilha",
  Use: "Utilizar",
  EnableThe: "Activar o",
  Feature: "Propriedade",
  HostAddress: "Endereço de Hospedeiro",

  //Logout
  ConfirmLogout: "Confirmar Sair",
  AreYouSureYouWantToLogout: "Tem a certeza que quer Sair?",

  //Select Attendant
  SelectAttendant: "Selecionar Atendedor",
  Next: "Proximo",
  None: "Nenhum",
  EnterPin: "Digitar Codigo",
  NoAttendant: "Sem Atendedor",
  PleaseSelectAnyAttendant: "Por favor selecionar qualquer Atendedor",
  PINError: "Erro de Codigo",
  PleaseEnterTheCorrectPINNumber:
    "Por favor digite o Numero do Codigo correcto",
  //Late Additionals
  SetTheShift: "Selecionar o Turno",
  AttendantAlreadyAdded: "Atendedor de Mesa já Inserido",
  NoItemBasedOnTheBarcode: "Não tem Item com base no Codígo de Barras",
  QuantityIsNotAllowed: "Quantidade não permitida",
  ReceiptLineIsModified: "Linha do Recibo foi Modificada",
  UnableToDeleteReceiptLine: "Não foi possivel apagar a linha do Recibo.",
  ConfirmOrderCancel: "Confirmar Cancelamento do Pedido",
  ConfirmOrderClose: "Confirmar Fecho do Pedido",
  WouldYouLikeToCancelTheOrder: "Gostaria de Cancelar o Pedido?",
  WouldYouLikeToCloseTheOrder: "Gostaria de Fechar o Pedido?",
  IsCancelled: "Está Cancelado",
  Order: "Pedido",
  ConfirmTableChange: "Confirme mudança de Mesa",
  WouldYouLikeToChangeTable: "Gostaria de mudar a Mesa?",
  TableNumberChanged: "Numero da Mesa Alterado",
  UnableToTakeAwayOrder: "Não foi possivel fazer o take-away do pedido.",
  SaveNew: "Salvar novo",
  Edit: "Editar",
  VerifyCode: "Verifique o codigo",
  Verify: "Verificar",
  ResendCode: "Re-enviar o Codigo",
  CashedOut: "Saida de Dinheiro feita",
  TaxPercentage: "Percentagem do Imposto",
  ItemName: "Nome do Item",
  AddNewItem: "Adicionar novo Item",
  WouldYouLikeToCreateNew: "Gostaria de criar um novo",
  CreateNew: "Criar Novo",
  From: "Apartir",
  To: "Para",
  EnterPinCode: "Digite o Codigo PIN",
  ZeroPriceIsNotAvailable: "Preço Zero não disponivel.",
  PaymentReceipt: "Recibo de Pagamento",
  TransactedOn: "Transação feita em",
  YouHaveSuccessfullyRegistered: "Você registou-se com sucesso",
  ReceiptItems: "Items de Recibo",
  Overage: "Acima de ",
  ErrorButton: "Erro de Botão",
  ForceSync: "Forçar Sincronização",
  SyncingErpnextData: "Sincronizando Dados ERPNext",
  SendPassword: "Enviar Senha",
  Back: "Voltar",
  Register: "Registar",
  Login: "Entrar",
  CreateAccount: "Criar Conta",
  FirstName: "Primeiro Nome",
  LastName: "Ultimo Nome",
  ConfirmPassword: "Confirmar Senha",
  ThereAreItemsAssociatedWithThisCategoryChangeOrDeleteTheItems:
    "Existem Itens associados a esta categoria. Modifique ou Apague os itens",
  SuccessfullyDeletedCategory: "Categoria Apagada com Sucesso",
  SuccessfullyDeletedItem: "Item Apagado com Sucesso",
  SuccessfullyDeletedDiscount: "Desconto Apagado com Sucesso",
  DeleteCategory: "Apagar Categoria?",
  DeleteItem: "Apagar Item?",
  DeleteDiscount: "Apagar Desconto?",
  WouldYouLikeToDeleteThisCategory: "Gostaria de Apagar esta Categoria?",
  WouldYouLikeToDeleteAnItem: "Gostaria de Apagar um Item?",
  WouldYouLikeToDeleteThisDiscount: "Gostaria de Apagar este Desconto?",
  SuccessfullyUpdatedCategory: "Categoria Actualizada com Sucesso",
  SuccessfullyUpdatedItem: "Item Actualizado com Sucesso",
  SuccessfullyUpdatedDiscount: "Desconto Actualizado com Sucesso",
  DiscountValueError: "Erro de Valor no Desconto",
  ValueCantBeGreaterThan100OrLessThan0:
    "Valor não pode ser maior que 100% ou menor que 0%",
  BarcodeAlreadyBeenUsed: "Codigo de Barras já foi usado",
  EnterValidItemName: "Digite um Nome de Item Valido",
  SuccessfullyPrintedTheBarcode: "Impressão de Codigo de Barras com Sucesso.",
  UnableToPrint: "Não foi possivel Imprimir",
  PleaseConnectYourPrinter: "Por favor conecte a sua Impressora",
  CheckYourEmail: "Verifique o seu Email.",
  NetworkConnectionFailed: "Falha na Ligação de Rede.",
  ReceiptConfirmation: "Confirmação de Recibo",
  InvalidEmail: "Email Invalido",
  PleaseEnterValidEmail: "Por favor digite um Email Valido",
  AreYouSureYouWantToReprintThisReceipt:
    "Tem a certeza que quer re-imprimir este Recibo?",
  UnableToConnectPrinter: "Não foi possivel ligar a Impressora",
  ReprintCompleted: "Re-impressão Terminada",
  EnterValidReason: "Digite um Motivo Valido",
  TransactionCompleted: "Transação Completada",
  AllDataWillBeLostWhenYouAreLoggedOutAsOwnerWouldYouLikeToProceed:
    "TODOS os dados serão perdidos quando você sair como Dono. Gostaria de Proceder?",
  Logout: "Sair",
  AttendantAlreadyExists: "Atendedor de Mesa já existe",
  SuccessfullyUpdatedAttendant: "Actualizou com Sucesso o Atendedor",
  PinCodeContainsSpecialCharacters: "Codigo Pin contêm caracteres especiais",
  DeleteAttendant: "Apagar Atendedor",
  AreYouSureYouWantToDeleteAttendant:
    "Tem a certeza que quer apagar o Atendedor?",
  SuccessfullyDeletedAttendant: "Apagou com Sucesso o Atendor",
  NoShiftsCreated: "Não foram criados os Turnos",
  BluetoothConnectionFailed: "Conecção Bluetooth Falhou",
  RoleError: "Erro de Regra",
  UnableToGoToListingIfYouAreTheOwnerReLogInAsOwnerInOrderToProceed:
    "Não foi possivel ir as Listagens. Case seja o dono, ligue-se como dono para proceder",
  UnableToRegisterEmailAddressIsAlreadyTaken:
    "Impossivel registar-se. Endereço de Email já foi inserido",
  UnableToRegisterConnectionFailed: "Impossivel registar-se. Ligação falhou",
  EmailAlreadyExists: "Email já existe",
  EmailIsAvailable: "Email não está disponivel",
  InputAValidEmail: "Digite um Email valido",
  OpenShift: "Abrir o Turno",
  InputValidRole: "Digite uma Regra Valida",
  SuccessfullyDeletedRole: "Apagou com Sucesso a Regra",
  DeleteRole: "Apagar a Regra",
  AreYouSureYouWantToDeleteRole: "Tem a certeza que quer apagar a Regra?",
  SuccessfullyAddedRole: "Regra Adicionada com Sucesso",

  //Actual Receipts
  Cashier: "Balcão: ",
  TransactionNo: "Transação Num.:",
  Qty: "Qtd",
  Purchases: "Compras",
  TotalAmount: "Total Geral",
  ThisServesAsYour: "Este serve como o seu",
  OfficialReceipt: "Recibo Oficial",
  POSProvider: "Provedor de POS:\n",
  AccredNo: "Accred. No.: \n",
  DateIssued: "Data de Emissão: \n",
  ValidUntil: "Valido Até: \n\n",
  ThisReceiptShallBeValidFor: "ESTE RECIBO É VALIDO ATÉ\n",
  FiveYearsFromTheDateOf: "CINCO(5) ANOS APARTIR DA DATA DE\n",
  ThePermitToUse: "A PERMISSÃO DE USO\n",
  FromDateMustBeGreaterThanOrEqualToDate:
    "Data (Apartir) deve ser maior que ou igual a Data (PARA)",
  NoItemSalesFrom: "Não tem Itens de Venda apartir",
  Date: "Data",
  Type: "Tipo",
  PrintedBy: "Imprimido por",
  Closed: "Fechado",
  PrintedOn: "Imprimido em",
  Change: "Troco",
  XRreading: "Leitura X",
  Language: "Lingua",
  PleaseRestartTheApplicationToUpdateLanguage:
    "Por favor re-iniciar a aplicação para actualizar a Lingua",
  AlreadyUpToDate: "Está actualizado",
  SyncSuccessful: "Sync com Sucesso",
  UnableToSync: "Não foi possivel Sync",
  InvalidUrl: "URL Invalido",
  CompanySettingsSaved: "Dados da Empresa salvos",
  RestoreDefault: "Restaurar por Defeito",
  AreYouSureYouWantToRestoreDefaultSettings:
    "Tem a certeza que quer restaurar as Configuraçãoes por Defeito?",
  DefaultSettingsRestored: "Restaurada Configurações por Defeito",
};
